import { render } from "./ButhiMapModal.vue?vue&type=template&id=ff99b67e&scoped=true"
import script from "./ButhiMapModal.vue?vue&type=script&lang=js"
export * from "./ButhiMapModal.vue?vue&type=script&lang=js"

import "./ButhiMapModal.vue?vue&type=style&index=0&id=ff99b67e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wkphi\\Desktop\\Programming\\buthigame - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff99b67e"]])

export default __exports__